import { Flex } from '@mantine/core'

import type { AdvisorChatShellProps } from '@/modules/advisors/users/pages/chat/components/ChatShell/ChatShell.types'
import { ChatWorkspace } from '@/modules/advisors/users/pages/chat/components/ChatWorkspace/ChatWorkspace'
import { UserSelect } from '@/modules/advisors/users/pages/chat/components/UserSelect/UserSelect'

import classes from './ChatShell.module.css'

export function AdvisorChatShell({
  isChatOpen,
  isLoading,
  onChatClose,
  onUserSearch,
  onUserSelect,
  searchedUser,
  selectedUser,
  users,
}: AdvisorChatShellProps) {
  return (
    <Flex className={classes.container}>
      <UserSelect
        isLoading={isLoading}
        onUserSearch={onUserSearch}
        onUserSelect={onUserSelect}
        searchedUser={searchedUser}
        selectedUserId={selectedUser?.id}
        users={users}
      />
      <Flex className={classes.chatContainer}>
        <ChatWorkspace
          isChatOpen={isChatOpen}
          onChatClose={onChatClose}
          selectedUser={selectedUser}
        />
      </Flex>
    </Flex>
  )
}
